var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverdue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "8 8 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1344_32243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.5C6.5 14.25 8.82324 11.5563 11.859 11.075C11.859 10.7156 11.859 10.3594 11.859 10C11.6976 10 11.5332 10 11.3718 10C10.8329 10 10.3974 9.55313 10.3974 9C10.3974 8.44687 10.8329 8 11.3718 8C11.859 8 12.3462 8 12.8333 8C13.3205 8 13.8077 8 14.2949 8C14.8338 8 15.2692 8.44687 15.2692 9C15.2692 9.55313 14.8338 10 14.2949 10C14.1335 10 13.9691 10 13.8077 10C13.8077 10.3594 13.8077 10.7156 13.8077 11.075C14.9495 11.2563 15.9878 11.75 16.8434 12.4688C17.0627 12.2438 17.2819 12.0188 17.5011 11.7938C17.8817 11.4031 18.4998 11.4031 18.8804 11.7938C19.2611 12.1844 19.2611 12.8187 18.8804 13.2094C18.6369 13.4594 18.3902 13.7125 18.1466 13.9625C18.2014 14.05 18.2562 14.1406 18.308 14.2312C18.0583 14.0844 17.7691 14 17.4615 14C16.5237 14 15.7655 14.775 15.7564 15.7344C15.7564 16.9969 15.7564 18.2625 15.7564 19.525C15.7625 20.6812 16.1157 21.7531 16.7155 22.6375C15.6438 23.4906 14.2949 24 12.8333 24C9.33478 24 6.5 21.0906 6.5 17.5ZM12.1026 14C12.1026 15.3344 12.1026 16.6656 12.1026 18C12.1026 18.4156 12.4284 18.75 12.8333 18.75C13.2383 18.75 13.5641 18.4156 13.5641 18C13.5641 16.6656 13.5641 15.3344 13.5641 14C13.5641 13.5844 13.2383 13.25 12.8333 13.25C12.4284 13.25 12.1026 13.5844 12.1026 14ZM16.7308 15.75C16.7308 15.3344 17.0566 15 17.4615 15C17.8665 15 18.1923 15.3344 18.1923 15.75C18.1923 15.8812 18.1923 16.0156 18.1923 16.1469C18.9688 15.4344 19.9918 15 21.1154 15C22.9149 15 24.4587 16.1125 25.1346 17.7C25.296 18.0781 25.1255 18.5219 24.7571 18.6875C24.3886 18.8531 23.9562 18.6781 23.7949 18.3C23.3442 17.2406 22.312 16.5 21.1154 16.5C20.2476 16.5 19.4712 16.8844 18.9353 17.5C19.255 17.5 19.5777 17.5 19.8974 17.5C20.3024 17.5 20.6282 17.8344 20.6282 18.25C20.6282 18.6656 20.3024 19 19.8974 19C19.0845 19 18.2745 19 17.4615 19C17.0566 19 16.7308 18.6656 16.7308 18.25V15.75ZM17.0962 21.3C16.9348 20.9219 17.1053 20.4781 17.4737 20.3125C17.8421 20.1469 18.2745 20.3219 18.4359 20.7C18.8865 21.7594 19.9187 22.5 21.1154 22.5C21.9832 22.5 22.7596 22.1156 23.2955 21.5C22.9758 21.5 22.653 21.5 22.3333 21.5C21.9284 21.5 21.6026 21.1656 21.6026 20.75C21.6026 20.3344 21.9284 20 22.3333 20C23.1463 20 23.9562 20 24.7692 20C25.1742 20 25.5 20.3344 25.5 20.75C25.5 21.5844 25.5 22.4156 25.5 23.25C25.5 23.6656 25.1742 24 24.7692 24C24.3643 24 24.0385 23.6656 24.0385 23.25C24.0385 23.1187 24.0385 22.9844 24.0385 22.8531C23.262 23.5656 22.2389 24 21.1154 24C19.3159 24 17.7721 22.8875 17.0962 21.3Z",
    fill: "url(#paint0_linear_1344_32243)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1344_32243",
    x: -5.5,
    y: 0,
    width: 43,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1344_32243"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1344_32243",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1344_32243",
    x1: 20.9564,
    y1: 28.1905,
    x2: 14.2879,
    y2: 4.14822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFABAB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdue);
export default __webpack_public_path__ + "static/media/overdue.0ab815d41f667cb8c70096ffa5fd9624.svg";
export { ForwardRef as ReactComponent };